import { User } from "@fairfleet/geotab";
import { getUserEmail } from "./getUserEmail";

export function getUserDisplayName(user: User) {
  if (!user.firstName) {
    return getUserEmail(user);
  }

  if (!user.lastName) {
    return user.firstName;
  }

  return `${user.firstName} ${user.lastName} (${getUserEmail(user)})`;
}
